export const generateSimpleHash = (input) => {
  function toHexString(byteArray) {
    return Array.from(byteArray, function (byte) {
      return ("0" + (byte & 0xff).toString(16)).slice(-2);
    }).join("");
  }

  function hashString(str) {
    const bytes = new Uint8Array(16);
    for (let i = 0; i < str.length; i++) {
      bytes[i % 16] = (bytes[i % 16] + str.charCodeAt(i)) % 256;
    }
    return bytes;
  }

  const byteArray = hashString(input);
  return toHexString(byteArray);
};
